import { Component, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state = { hasError: false }
  static getDerivedStateFromError() { return { hasError: true } }
  componentDidCatch(error: Error) { console.error('ErrorBoundary caught:', error) }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Something went wrong</h1>
            <p className="text-gray-600 mb-6">An unexpected error occurred.</p>
            <div className="flex items-center justify-center gap-3">
              <button onClick={() => this.setState({ hasError: false })} className="btn-primary btn-md">
                Try again
              </button>
              <a href="/" className="btn-secondary btn-md">Go Home</a>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
